import { render, staticRenderFns } from "./CompanyReport.vue?vue&type=template&id=272681f3&"
import script from "./CompanyReport.vue?vue&type=script&lang=js&"
export * from "./CompanyReport.vue?vue&type=script&lang=js&"
import style0 from "./CompanyReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-company-evaluate/src/components/companyEvaluate/CompanyReport.vue"
export default component.exports